import type { TransactionActionCapability, TransactionActionExecutionProfile } from './proposalTypes';

// Per-capability model/temperature/token/timeout/retry configuration, keyed the same way as the
// capability registry (capabilities.ts). Kept separate from capability.ts so tuning a model or
// timeout doesn't require touching capability wiring.
export const transactionActionExecutionProfiles: Record<
  TransactionActionCapability | 'wellness_insights',
  TransactionActionExecutionProfile
> = {
  recategorize: {
    model: 'gpt-5-mini',
    temperature: 0.1,
    maxOutputTokens: 4000,
    timeoutMs: 8000,
    retryModel: 'gpt-5',
  },
  rename_payee: {
    model: 'gpt-5-mini',
    temperature: 0,
    maxOutputTokens: 3000,
    timeoutMs: 5000,
    retryModel: 'gpt-5',
  },
  cleanup_transaction: {
    model: 'gpt-5-mini',
    temperature: 0.1,
    maxOutputTokens: 3000,
    timeoutMs: 8000,
    retryModel: 'gpt-5',
  },
  create_rule: {
    model: 'gpt-5',
    temperature: 0.1,
    maxOutputTokens: 8000,
    timeoutMs: 12000,
    retryModel: 'gpt-5',
  },
  // Wellness uses a metric snapshot rather than selected transaction IDs.
  wellness_insights: {
    model: 'gpt-5-mini',
    temperature: 0.1,
    maxOutputTokens: 4000,
    timeoutMs: 8000,
    retryModel: 'gpt-5',
  },
};
